import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { formatOrderType, getOrderStatusColor } from 'src/utils/designUtils';
import { toggleOrderModal } from '../../slices/modals';
import Pill from '..//atoms/Pill';
import OrderCardItem from '../molecules/OrderCardItem';
import GlobalModal from './GlobalModal';
import css from './OrderModal.module.scss';

export default function OrderModal(props) {
  // const {orderId} = props
  const dispatch = useDispatch();
  const { currentOrder, status } = useSelector((state) => state.order);
  const { order } = useSelector((state) => state.modals);
  const navigate = useNavigate();

  return currentOrder && order.isOpen && !status.pastOrderDetails.isLoading ? (
    <GlobalModal
      title={`#${currentOrder.orderRef}`}
      closeFunction={() => {
        const params = new URLSearchParams(window.location.search);

        dispatch(toggleOrderModal({ isOpen: false }));

        params.delete('orderId');

        navigate({ search: params.toString() }, { replace: true });
      }}
    >
      <div className={css.merchant}>
        <div className={css['merchant-name']}>
          <h4>Customer: {currentOrder.shopperName}</h4>
          <Pill
            label={currentOrder.status}
            color={getOrderStatusColor(currentOrder.status).slice(0, -4)}
            variant="secondary"
          />
        </div>

        <div className={css['merchant__details']}>
          <div className={css['order-info']}>
            <table className={css['price-table']}>
              <tbody>
                <tr>
                  <td>Type:</td>
                  <td>
                    <i className={`fad fa-${formatOrderType(currentOrder.orderType).icon}`} />
                    {formatOrderType(currentOrder.orderType).text}
                    {/*
                    Show only if delivery type is in-house delivery
                    <br />
                    (In-House)*/}
                  </td>
                </tr>

                {currentOrder.orderType === 'delivery' && !currentOrder.deliveryDetails?.isNull && (
                  <tr>
                    <td>Address:</td>
                    <td>{currentOrder.deliveryDetails?.address}</td>
                  </tr>
                )}
                {currentOrder.orderType === 'delivery' && !currentOrder.deliveryDetails?.isNull && (
                  <tr>
                    <td>phone:</td>
                    <td>{currentOrder.deliveryDetails?.phone}</td>
                  </tr>
                )}

                {/* Show only if delivery type is in-house delivery */}
                {/* <tr>
                  <td>Delivery:</td>
                  <td>$5</td>
                </tr> */}

                <tr>
                  <td>Placed:</td>
                  <td>
                    {new Date(currentOrder.orderDate).toLocaleString('en-US', {
                      month: 'short',
                      day: 'numeric',
                      hour: 'numeric',
                      minute: '2-digit',
                      hour12: false,
                    })}
                  </td>
                </tr>

                <tr>
                  <td>Expected:</td>
                  <td>
                    {new Date(currentOrder.expectedDate).toLocaleString('en-US', {
                      month: 'short',
                      day: 'numeric',
                      hour: 'numeric',
                      minute: '2-digit',
                      hour12: false,
                    })}
                  </td>
                </tr>

                {/* Only show this is it's delivery. Also it's good */}

                {/* {currentOrder.orderType == 'deivery' ? (
                  <tr>
                    <td>Delivery Fee:</td>
                    <td>$55</td>
                  </tr>
                ) : null} */}
                <tr>
                  <td>Tax:</td>
                  <td>${currentOrder.tax.toFixed(2)}</td>
                </tr>

                {currentOrder.orderType === 'delivery' && !currentOrder.deliveryDetails?.isNull && (
                  <tr>
                    <td>Delivery Fee:</td>
                    <td>
                      $
                      {(currentOrder.deliveryDetails?.fee
                        ? currentOrder.deliveryDetails?.fee
                        : 0
                      ).toFixed(2)}
                    </td>
                  </tr>
                )}
                {currentOrder.orderType === 'delivery' && !currentOrder.deliveryDetails?.isNull && (
                  <tr>
                    <td>Tip:</td>
                    <td>
                      $
                      {(currentOrder.deliveryDetails?.tip
                        ? currentOrder.deliveryDetails?.tip
                        : 0
                      ).toFixed(2)}
                    </td>
                  </tr>
                )}

                {currentOrder.comission > 0 && (
                  <tr>
                    <td>Service Fee:</td>
                    <td> ${currentOrder.comission.toFixed(2)}</td>
                  </tr>
                )}
                <tr>
                  <td>Total:</td>
                  <td>${currentOrder.merchantShare.toFixed(2)}</td>
                </tr>
              </tbody>
            </table>
          </div>

          {currentOrder.products.map((product) => {
            return (
              <div className={css['merchant__items']} key={product.name}>
                <OrderCardItem
                  name={product.name}
                  actualPrice={product.price.toFixed(2)}
                  quantity={product.qty}
                  storeCategory="restaurant"
                  photo={product.photos?.[0]}
                  addons={product.addOns}
                />
              </div>
            );
          })}
        </div>
      </div>
    </GlobalModal>
  ) : (
    <></>
  );
}
